var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"breadcrumbs"},_vm._l((_vm.breadcrumbs),function(item,key){return _c('li',{key:key,staticClass:"breadcrumbs__item"},[_c('router-link',{attrs:{"to":_vm.breadcrumbs
				.filter(function (el, id) { return id <= key; })
				.map(function (el) { return el.link; })
				.join('/') || '/'}},[_vm._v(" "+_vm._s(_vm.breadcrumbs.length - 1 > key ? decodeURI(item.name) + " >" : decodeURI(item.name))+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }